// extracted by mini-css-extract-plugin
export var badgeTextContainer = "_3r-2";
export var blackBorderOnHover = "_3r-7";
export var cell = "_3r-6";
export var cellContainer = "_3r-3";
export var checked = "_3r-8";
export var disabled = "_3r-5";
export var featuredIconCellContainer = "_3r-9";
export var featuredIconTextContainer = "_3r-b";
export var featuredIconWrapper = "_3r-a";
export var noBorder = "_3r-c";
export var orangeSelectedRow = "_bx-3";
export var overflowableText = "_3r-0";
export var overflowableTextContainer = "_3r-1";
export var row = "_3s-0";
export var rowCheckboxCell = "_3r-4";
export var selectableTable = "_bx-2";